import React, {Component} from 'react'
import Settings from '../../Settings'
import ReactPlayer from 'react-player/lib/players/FilePlayer'
import {Page, Container169} from './../common/StyledComponents'
import ReactGA from 'react-ga'
import {Container, Button, ButtonIcon, ButtonText, ExternalButton, ButtonTextSmall} from './Components'

import iconPlayNormal from './../../theme/img/play-normal.png'
import iconPlayHover from './../../theme/img/play-hover.png'
import iconMenuNormal from './../../theme/img/menu-normal.png'
import iconMenuHover from './../../theme/img/menu-hover.png'
import iconInfoNormal from './../../theme/img/info-normal.png'
import iconInfoHover from './../../theme/img/info-hover.png'
import iconExternalLinkNormal from './../../theme/img/customer-zone-normal.png'
import iconExternalLinkHover from './../../theme/img/customer-zone-hover.png'
import iconShareLinkedInNormal from './../../theme/img/linkedin-normal.png'
import iconShareLinkedInHover from './../../theme/img/linkedin-hover.png'
import iconShareFacebookNormal from './../../theme/img/facebook-normal.png'
import iconShareFacebookHover from './../../theme/img/facebook-hover.png'
import iconDownloadAppNormal from './../../theme/img/download-app-normal.png'
import iconDownloadAppHover from './../../theme/img/download-app-hover.png'
import iconCopyUrlNormal from './../../theme/img/url-normal.png'
import iconCopyUrlHover from './../../theme/img/url-hover.png'

import bgVideo from './../../theme/vid/end-bg.mp4'

const copyToClipboard = str => {
  const el = document.createElement('textarea')
  el.value = str
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

export class VideoEnd extends Component {
  handleClick(url, gaCategory, gaLabel, popup = false) {
    if (popup === false) {
      window.open(url)
    } else {
      window.open(url, popup, 'height=360,width=640')
    }

    ReactGA.event({
      category: gaCategory,
      action: 'Click',
      label: gaLabel,
    })
  }

  handleContactClick = (currentVideo, category, locale) => e => {
    this.handleClick(
      category.contactUrl[locale],
      'Contact',
      `${currentVideo.label[locale]} from category ${category.label[locale]}`
    )
  }

  handleExternalLinkClick = (currentVideo, category, locale) => e => {
    this.handleClick(
      category.externalLink[locale],
      'External Link (Client Zone)',
      `${currentVideo.label[locale]} from category ${category.label[locale]}`
    )
  }

  handleShareLinkedInClick = (currentVideo, category, locale) => e => {
    this.handleClick(
      `https://www.linkedin.com/shareArticle?mini=true&url=${category.shareLinkedIn[locale]}`,
      'Share on LinkedIn',
      `${currentVideo.label[locale]} from category ${category.label[locale]}`,
      'Share'
    )
  }

  handleShareFacebookClick = (currentVideo, category, locale) => e => {
    this.handleClick(
      `https://www.facebook.com/sharer/sharer.php?u=${category.shareFacebook[locale]}`,
      'Share on Facebook',
      `${currentVideo.label[locale]} from category ${category.label[locale]}`,
      'Share on Facebook'
    )
  }

  handleDownloadAppClick = (currentVideo, category, locale) => e => {
    this.handleClick(
      category.downloadApp[locale],
      'Download app',
      `${currentVideo.label[locale]} from category ${category.label[locale]}`
    )
  }

  handleCopyUrlClick = (currentVideo, category, locale) => e => {
    copyToClipboard(category.copyUrl[locale])

    ReactGA.event({
      category: 'Copy URL',
      action: 'Click',
      label: `${currentVideo.label[locale]} from category ${category.label[locale]}`,
    })
  }

  render() {
    const {
      match: {
        params: {locale, categoryKey, videoKey},
      },
    } = this.props

    const category = Settings.categories.find(category => category.key === categoryKey)
    const videosInCategory = category.videos
    const currentVideoIndex = videosInCategory.findIndex(video => video.key === videoKey)
    const currentVideo = videosInCategory[currentVideoIndex]
    const nextVideo = videosInCategory[currentVideoIndex < videosInCategory.length - 1 ? currentVideoIndex + 1 : 0]

    ReactGA.event({
      category: 'Video',
      action: 'End',
      label: `${currentVideo.label[locale]} from category ${category.label[locale]}`,
    })

    return (
      <Page>
        <Container169>
          {<ReactPlayer url={bgVideo} playing controls={false} loop width="100%" height="100%" />}
        </Container169>
        <Container>
          <Button to={`/${locale}/category/${categoryKey}/video/${nextVideo.key}`}>
            <ButtonIcon normal={iconPlayNormal} hover={iconPlayHover} />
            <ButtonText>{Settings.texts.nextVideo[locale]}</ButtonText>
          </Button>
          <Button to={`/${locale}/category/${categoryKey}`}>
            <ButtonIcon normal={iconMenuNormal} hover={iconMenuHover} />
            <ButtonText>{Settings.texts.backToMenu[locale]}</ButtonText>
          </Button>
          {category.contactUrl[locale] ? (
            <ExternalButton onClick={this.handleContactClick(currentVideo, category, locale)}>
              <ButtonIcon normal={iconInfoNormal} hover={iconInfoHover} />
              <ButtonTextSmall>{Settings.texts.contact[locale]}</ButtonTextSmall>
            </ExternalButton>
          ) : null}
          {category.externalLink[locale] ? (
            <ExternalButton onClick={this.handleExternalLinkClick(currentVideo, category, locale)}>
              <ButtonIcon normal={iconExternalLinkNormal} hover={iconExternalLinkHover} />
              <ButtonText>{Settings.texts.externalLink[locale]}</ButtonText>
            </ExternalButton>
          ) : null}
          {category.downloadApp[locale] ? (
            <ExternalButton onClick={this.handleDownloadAppClick(currentVideo, category, locale)}>
              <ButtonIcon normal={iconDownloadAppNormal} hover={iconDownloadAppHover} />
              <ButtonText>{Settings.texts.downloadApp[locale]}</ButtonText>
            </ExternalButton>
          ) : null}
          {category.copyUrl[locale] ? (
            <ExternalButton onClick={this.handleCopyUrlClick(currentVideo, category, locale)}>
              <ButtonIcon normal={iconCopyUrlNormal} hover={iconCopyUrlHover} />
              <ButtonText>{Settings.texts.copyUrl[locale]}</ButtonText>
            </ExternalButton>
          ) : null}
          {category.shareLinkedIn[locale] ? (
            <ExternalButton onClick={this.handleShareLinkedInClick(currentVideo, category, locale)}>
              <ButtonIcon normal={iconShareLinkedInNormal} hover={iconShareLinkedInHover} />
              <ButtonText>{Settings.texts.shareLinkedIn[locale]}</ButtonText>
            </ExternalButton>
          ) : null}
          {category.shareFacebook[locale] ? (
            <ExternalButton onClick={this.handleShareFacebookClick(currentVideo, category, locale)}>
              <ButtonIcon normal={iconShareFacebookNormal} hover={iconShareFacebookHover} />
              <ButtonText>{Settings.texts.shareFacebook[locale]}</ButtonText>
            </ExternalButton>
          ) : null}
        </Container>
      </Page>
    )
  }
}
